import { Vector3 } from "three";
import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";

interface CanvasStore {
  cameraData: {
    position: { x: number; y: number; z: number };
    target: { x: number; y: number; z: number };
  };

  camRef: any;
  setCamRef: (camRef: any) => void;

  setCameraData: (cameraData: {
    position: { x: number; y: number; z: number };
    target: { x: number; y: number; z: number };
  }) => void;
  camera: any;
  setCamera: (camera: any) => void;

  polar: number;
  azimuth: number;

  isFull3D: boolean;

  setSpherical: (spherical: { polar: number; azimuth: number }) => void;

  distance: number;
  setDistance: (distance: number) => void;

  canvasReady: boolean;
  setCanvasReady: (canvasReady: boolean) => void;

  speed: number;
  setSpeed: (speed: number) => void;

  touchPoints: any[];
  setTouchPoints: (touchPoints: any[]) => void;
}

export const useCanvasStore = create(
  subscribeWithSelector<CanvasStore>((set) => ({
    isFull3D: false,
    camRef: null,
    setCamRef: (camRef) => set({ camRef }),
    canvasReady: false,
    setCanvasReady: (canvasReady) => set({ canvasReady }),
    cameraData: {
      position: new Vector3(-5, 3, -.5),
      target: new Vector3(-0.15, .6, 0.6),
    },

    setCameraData: (cameraData) => set({ cameraData }),
    camera: null,
    setCamera: (camera) => set({ camera }),

    polar: 0,
    azimuth: 0,

    distance: 0,
    setDistance: (distance) => set({ distance }),

    speed: 0,
    setSpeed: (speed) => set({ speed }),

    setSpherical: (spherical) =>
      set({ polar: spherical.polar, azimuth: spherical.azimuth }),

    touchPoints: [],
    setTouchPoints: (touchPoints) => set({ touchPoints }),
  })),
);
